import $ from 'jquery';

export default function cf7JobForm() {
    const $forms = $('.cf7-job-form');

    if (!$forms.length) return;

    $forms.each(function () {
        const $formWrap = $(this);
        const $realForm = $formWrap.closest('form');
        const $cf7Box = $formWrap.closest('.wpcf7');

        const $stepPanels = $formWrap.find('.cf7-step-panel');
        const $dots = $formWrap.find('.cf7-step-dot');
        const $progressFill = $formWrap.find('.cf7-progress-fill');
        const $nextBtn = $formWrap.find('.cf7-next');
        const $prevBtn = $formWrap.find('.cf7-prev');
        const $errorBox = $formWrap.find('.cf7-step-error');

        function showStep(stepNumber) {
            $stepPanels.each(function () {
                const $panel = $(this);
                const panelStep = Number($panel.attr('data-step'));
                const isActive = panelStep === stepNumber;

                $panel.toggleClass('is-active', isActive);

                if (isActive) {
                    $panel.removeAttr('hidden');
                } else {
                    $panel.attr('hidden', true);
                }
            });

            $dots.each(function () {
                const $dot = $(this);
                const dotStep = Number($dot.attr('data-step-target'));

                $dot.toggleClass('is-active', dotStep === stepNumber);
            });

            if ($progressFill.length) {
                $progressFill.css('width', stepNumber === 1 ? '50%' : '100%');
            }
        }

        function clearStep1Errors() {
            $errorBox.text('');

            $formWrap
                .find('[name="bewerbung_als"], [name="ausbildung_als"]')
                .removeClass('cf7-input-invalid');

            $formWrap
                .find('[data-required-group="erfahrung"], [data-required-group="arbeitsbeginn"]')
                .removeClass('cf7-invalid');
        }

        function validateStep1() {
            clearStep1Errors();

            let valid = true;
            let $firstInvalid = $();

            $formWrap.find('[name="bewerbung_als"], [name="ausbildung_als"]').each(function () {
                const $field = $(this);

                if (!$.trim($field.val())) {
                    valid = false;
                    $field.addClass('cf7-input-invalid');

                    if (!$firstInvalid.length) {
                        $firstInvalid = $field;
                    }
                }
            });

            ['erfahrung', 'arbeitsbeginn'].forEach(function (groupName) {
                const $checked = $formWrap.find(`[name="${groupName}"]:checked`);
                const $fieldset = $formWrap.find(`[data-required-group="${groupName}"]`);

                if (!$checked.length) {
                    valid = false;
                    $fieldset.addClass('cf7-invalid');

                    if (!$firstInvalid.length) {
                        $firstInvalid = $fieldset;
                    }
                }
            });

            if (!valid) {
                $errorBox.text('Bitte füllen Sie alle Pflichtfelder im ersten Schritt aus.');

                if ($firstInvalid.length) {
                    $('html, body').animate(
                        {
                            scrollTop: $firstInvalid.offset().top - 120,
                        },
                        400
                    );
                }
            }

            return valid;
        }

        $nextBtn.on('click', function () {
            if (validateStep1()) {
                showStep(2);
            }
        });

        $prevBtn.on('click', function () {
            showStep(1);
        });

        $dots.on('click', function () {
            const targetStep = Number($(this).attr('data-step-target'));

            if (targetStep === 1) {
                showStep(1);
                return;
            }

            if (targetStep === 2 && validateStep1()) {
                showStep(2);
            }
        });

        $formWrap.on('input change', '[name="bewerbung_als"], [name="ausbildung_als"]', function () {
            $(this).removeClass('cf7-input-invalid');
        });

        $formWrap.on('change', '[name="erfahrung"]', function () {
            $formWrap.find('[data-required-group="erfahrung"]').removeClass('cf7-invalid');
        });

        $formWrap.on('change', '[name="arbeitsbeginn"]', function () {
            $formWrap.find('[data-required-group="arbeitsbeginn"]').removeClass('cf7-invalid');
        });

        if ($cf7Box.length) {
            $cf7Box.on('wpcf7invalid', function () {
                const $invalidInStep1 = $formWrap.find('.cf7-step-panel[data-step="1"] .wpcf7-not-valid');
                const $invalidInStep2 = $formWrap.find('.cf7-step-panel[data-step="2"] .wpcf7-not-valid');

                if ($invalidInStep1.length) {
                    showStep(1);
                } else if ($invalidInStep2.length) {
                    showStep(2);
                }
            });

            $cf7Box.on('wpcf7mailsent', function () {
                showStep(1);
                $errorBox.text('');
                $formWrap.find('.cf7-input-invalid, .cf7-invalid').removeClass('cf7-input-invalid cf7-invalid');

                if ($realForm.length) {
                    $realForm[0].reset();
                }
            });
        }

        showStep(1);
    });
}